import { ChatModule } from 'app/services/helpCenter';

import { ChatModuleType } from '../copied/models/ChatModules';
import useFetchHelpCenter from './fetch/useFetchHelpCenter';

export function findModule(modules: ChatModule[], moduleType: ChatModuleType): Partial<ChatModule> | undefined {
  return modules.find((module) => module.module_type === moduleType);
}

export default function useModule(moduleType: ChatModuleType): Partial<ChatModule> | undefined {
  const { data: helpCenter } = useFetchHelpCenter();

  const isNNOnline = helpCenter?.nurses_are_online;

  const module = findModule(helpCenter?.modules ?? [], moduleType);

  if (isNNOnline && module?.is_active_rule === 'nn_offline') {
    return undefined;
  }

  return module;
}
